// store/modules/meterReset.js
import Vue from 'vue';
import {storagePath, apiUrl} from '@/config'
export default {
    namespaced: true,
    state: {
      resets: [],
      pagination: {}
    },
    getters: {
      meterResets: state => state.resets,
      meterResetPagination: state => state.pagination
    },
    actions: {
      async FETCH_METER_RESETS({ commit }, { site_id, page = 1 }) {
        const res = await Vue.http.get(apiUrl + 'meter-reset', {
          params: { site_id, page }
        });
        commit('SET_RESETS', res.body.data);
      },
      async ADD_METER_RESET({ dispatch }, payload) {
        try {
          const res = await Vue.http.post(apiUrl + 'meter-reset', payload);
      
          // Only refresh if status is true
          if (res.body.status) {
            await dispatch('FETCH_METER_RESETS', { site_id: payload.site_id });
          }
      
          return res.body;
        } catch (err) {
          throw err;
        }
      }
    },
    mutations: {
        CLEAR_METER_RESETS(state) {
            state.meterResets = [];
            state.pagination = {};
          },
      SET_RESETS(state, data) {
        state.resets = data.data;
        state.pagination = {
          total: data.total,
          per_page: data.per_page,
          current_page: data.current_page
        };
      }
    }
  }


// WEBPACK FOOTER //
// ./src/store/modules/meterReset.js